// Mobile swipe between the first two grid images. Moved out of product-grid-item-lite so it ships once, not per card.
(function() {
  if (window.__yb_grid_swiper) return;
  window.__yb_grid_swiper = true;
  if (window.matchMedia('(min-width: 750px)').matches) return;

  var startX, startY, images, currentIdx, moved;

  function getImages(container) {
    return Array.from(container.querySelectorAll('product-grid-item-image'));
  }

  function activateImage(imgs, idx) {
    imgs.forEach(function(img, i) {
      var active = i === idx;
      img.classList.toggle('is-active', active);
      if (active) {
        img.setAttribute('data-grid-current-image', '');
        var tmpl = img.querySelector('template');
        if (tmpl) { img.appendChild(document.importNode(tmpl.content, true)); tmpl.remove(); }
      } else {
        img.removeAttribute('data-grid-current-image');
      }
    });
    var wrap = imgs[0] && imgs[0].closest('.product-grid-item__images');
    if (wrap) {
      wrap.querySelectorAll('.grid-swiper-dot').forEach(function(dot, i) {
        dot.classList.toggle('active', i === idx);
      });
    }
  }

  document.addEventListener('touchstart', function(e) {
    var c = e.target.closest('.product-grid-item__images');
    if (!c) return;
    var imgs = getImages(c);
    if (imgs.length < 2) return;
    images = imgs;
    currentIdx = imgs.findIndex(function(el) { return el.classList.contains('is-active'); });
    if (currentIdx < 0) currentIdx = 0;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    moved = false;
  }, { passive: true });

  document.addEventListener('touchmove', function(e) {
    if (!images) return;
    var dx = Math.abs(e.touches[0].clientX - startX);
    var dy = Math.abs(e.touches[0].clientY - startY);
    if (dx > dy && dx > 8) moved = true;
  }, { passive: true });

  document.addEventListener('touchend', function(e) {
    if (!images || !moved) { images = null; return; }
    var dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 40) {
      var next = currentIdx + (dx < 0 ? 1 : -1);
      if (next >= 0 && next < images.length) {
        currentIdx = next;
        activateImage(images, currentIdx);
      }
    }
    images = null;
    moved = false;
  }, { passive: true });
})();
